import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { DeviceService } from './device.service';

@Injectable({
	providedIn: 'root'
})
export class EducationService {

	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService, private deviceService: DeviceService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.updateHeaders();
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
			this.updateHeaders();
		});

		this.updateHeaders();

	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json'
		})
	};

	private updateHeaders() {
		const uuid = this.deviceService.getDeviceUUID();
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		if (this.config && this.config.apiCredentials && this.config.apiCredentials.clientId && this.user && this.user.user && this.user.user.userid) {
			headers = headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId + '_' + this.user.user.userid);
		}
		headers = headers.set('X-Device-UUID', uuid);
		this.httpOptions.headers = headers;
	}
	
	public getEvents(){
		const method = 'education';
		return this.http.get(this.setEndPoint(method))
	}
	
	public getEvent(data){
		const method = 'education/event';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public saveEvent(data){
		const method = 'education/saveevent';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public deleteEvent(data){
		const method = 'education/deleteevent';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public toggleEvent(data){
		const method = 'education/statustoggle';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getAttendees(data){
		const method = 'education/attendees';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}

	public removeAtendee(data) {
		const method = 'education/removeAtendee';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
		  catchError(this.handleError('education', data))
		);
	  }
	  public removeRegistration(data) {
		const method = 'education/removereg';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
		  catchError(this.handleError('education', data))
		);
	  }
	
	public getLocations(){
		const method = 'education/locations';

		return this.http.get(this.setEndPoint(method))
	}
	public saveLocation(data){
		const method = 'education/savelocation';

		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public deleteLocation(data){
		const method = 'education/deletelocation';

		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getRewards(){
		const method = 'education/rewards';

		return this.http.get(this.setEndPoint(method))
	}
	public saveReward(data){
		const method = 'education/savereward';

		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public deleteReward(data){
		const method = 'education/deletereward';

		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getRegions(){
		const method = 'education/regions';

		return this.http.get(this.setEndPoint(method))
	}
	public getProducts(data){
		const method = 'education/products';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public uploadEduFile(formdata: any, eventid: any) {
		const method = 'education/upload&id=' + eventid;
		return this.http.post(this.setEndPoint(method), formdata, this.httpOptions).pipe(
			catchError(this.handleError(method, formdata))
		);
	}
	public getEventByStockId(data: any){
		const method = 'education/stockid';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getVoucherReport(data: any){
		const method = 'education/voucherreport';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getHistoryData(data: any){
		const method = 'education/edit';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public updateReg(data: any){
		const method = 'education/updatereg';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getCities(){
		const method = 'education/city';

		return this.http.get(this.setEndPoint(method))
	}
	public getHosts(){
		const method = 'education/hosts';

		return this.http.get(this.setEndPoint(method))
	}
	public getYears(){
		const method = 'education/year';

		return this.http.get(this.setEndPoint(method))
	}
	public getSearch(data: any){
		const method = 'education/search';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	public getEduNumbers(data: any){
		const method = 'education/report';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('education', data))
		);
	}
	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}
}
